import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "../../config";
import vAdminformat from "../../adminFormat";
import { headers } from "../../token";


const DailyMetalFix = () => {

    const server_backend = config.API_URL;
    const [MetalList, setMetalList] = useState([]);

    useEffect(() => {
        const getMetal = async () => {
            try {
                const response = await axios.post(`${server_backend}/materials/types/lastprice`,{
                    date_lastprice: "2025-02-18"
                }, headers);
                //console.log(response.data)
                if (response.data.RES_CODE === "00") {
                    setMetalList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getMetal();
    }, []);

    const UpdateLastPrice = async () => {
        try {
            const response = await axios.post(`${server_backend}/materials/types/lastprice`, headers);

            if (response.data.RES_CODE === "00") {
                setMetalList(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title mb-0">Daily Metal Fix</h4>
                        <p>Prices for Gold, Silver, Platinum and Palladium
                        </p>
                    </div>
                    {/* <div className="d-flex justify-content-end">
                        <button className="btn btn-secondary p-2 m-2" onClick={UpdateLastPrice}>Update Last Price</button>
                    </div> */}
                    <div className="card-body">
                        <div
                            className="table-responsive table-card mb-4"
                            style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
                        >
                            <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                <thead className="table-light text-muted">
                                    <tr>
                                        <th className="th-hover" >ID</th>
                                        <th className="th-hover" >Name</th>
                                        <th className="th-hover" >Code</th>
                                        <th className="th-hover" >Last Price (GBP)</th>
                                        <th className="th-hover" >Last Update</th>
                                    </tr>
                                </thead>

                                <tbody className="list form-check-all">
                                    {MetalList.map((Metal_L) => (
                                        <tr key={Metal_L.matt_ID}>
                                            <th scope="row">
                                                <div className="form-check">
                                                    {Metal_L.matt_ID}
                                                </div>
                                            </th>

                                            <td className="due_date">{Metal_L.name}</td>
                                            <td className="due_date">{Metal_L.comment}</td>
                                            <td className="due_date">{parseFloat(Metal_L.lastprice).toFixed(2)}</td>
                                            <td className="date_lastprice">{vAdminformat.FormatDateTime(Metal_L.date_lastprice)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="row g-0 text-center text-sm-start">
                            <div className="col-sm-6">
                            </div>
                            <div className="col-sm-6">
                                <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )

}

export default DailyMetalFix;